<div class="page404-container">
  {{'PAGES.404.TITLE' | translate}}
  <div class="hint" [innerHTML]="'PAGES.404.EXPLANATION' | translate">

  </div>
</div>
